export const itResources={
  translation: {
    underConstruction: {
      title: "Torniamo subito",
      subtitle: "Il nostro store è attualmente in manutenzione.",
      autoreload: "Nuovo tentativo automatico tra 30 secondi…",
    },
    almostThere: "Quasi fatto!",
    pleseVerifyIdentityToCompletePurchase: "Per favore, verifica la tua identità per completare l'acquisto.",
    languageChanged: "Lingua cambiata",
    selectedLanguage: "L'italiano è ora selezionato",
    dark: "Scuro",
    light: "Chiaro",
    systemPreferences: "Preferenze di sistema",
    changeApplicationTheme: "Seleziona il tema dell'applicazione",
    applicationTheme: "Tema dell'applicazione",
    darkDescription: "Benvenuto nel lato oscuro, abbiamo i biscotti!",
    lightDescription: "Abbraccia la luce, nobile giocatore!",
    autoDescription: "Lascia che il tuo sistema decida il tuo destino!",
    welcome: "Benvenuto",
    welcomeToBigswiss: "Benvenuto in Bigswiss",
    completeProfileMessage: "Completa il tuo profilo",
    selectLanguage: "Seleziona la lingua predefinita",
    selectLanguageLabel: "Seleziona lingua",
    gdprFadpDescription:
      "Utilizziamo i cookie per mantenere il sito funzionante e migliorare la tua esperienza. Selezionando 'Accetta solo i cookie necessari' acconsenti ai cookie essenziali richiesti per le funzionalità di base, inclusi quelli dei nostri fornitori di pagamento autorizzati per transazioni sicure. Selezionando 'Accetta tutti i cookie' consenti anche i cookie facoltativi di analisi e pubblicità, così da poter migliorare ulteriormente i nostri servizi.",
    kycAdditionalNotice:
      "Per alcuni ordini potremmo dover verificare la tua identità (KYC) per prevenire le frodi o rispettare gli obblighi normativi. Condivideremo solo i dati necessari con i nostri partner di pagamento e verifica di fiducia.",
    kycConsentTitle: "Verify your identity",
    kycConsentMessage:
      "For high-value or high-risk orders we may need to verify your identity. This helps us keep your account secure and comply with legal requirements before we capture the payment.",
    kycConsentLabel:
      "I consent to identity verification (including facial image processing) for fraud prevention and compliance. I have read the <0>Privacy Policy</0> and <1>Terms</1>.",
    kycConsentContinue: "I agree and continue",
    kycConsentError: "Please consent to identity verification to continue.",
    paymentRiskNotice:
      "We share limited device and order data with authorized payment and fraud-prevention providers for security. See our <0>Privacy Policy</0>.",
    acceptTerms: "Accetto i <0>Termini di servizio</0> e l'<1>Informativa sulla privacy</1>.",
    acceptNecessary: "Solo Essenziali",
    acceptAll: "Accetta Tutto",
    termsWarning:
      "Si prega di accettare i termini e le condizioni per procedere.",
    termsPage: {
      seoTitle: "Termini e condizioni - Bigswiss GmbH",
      seoDescription:
        "Consulta i Termini e Condizioni di Bigswiss GmbH aggiornati il 4 ottobre 2025 con informazioni su prodotti, ordini, consegna, resi e obblighi dei clienti.",
      heading: "Termini e condizioni",
      lastUpdated: "Ultimo aggiornamento: 4 ottobre 2025",
      section1: {
        title: "1. Introduzione",
        p1: "I presenti Termini e Condizioni ('Termini') disciplinano il tuo accesso ai servizi e al sito web di Bigswiss GmbH ('Bigswiss', 'noi' o 'nostro'). Accedendo al nostro sito web o acquistando i nostri prodotti, accetti di essere vincolato da questi Termini e da tutte le politiche in essi richiamate (inclusa la nostra Informativa sulla privacy). Se non sei d'accordo con una qualsiasi parte di questi Termini, non devi utilizzare i nostri servizi né il sito web.",
        p2: "Possiamo aggiornare periodicamente i presenti Termini. Pubblicheremo ogni modifica indicando una nuova data di 'Ultimo aggiornamento'. L'uso continuato dei nostri servizi dopo tali aggiornamenti costituisce accettazione dei Termini modificati.",
      },
      section2: {
        title: "2. Descrizione di prodotti e servizi",
        p1: "Bigswiss GmbH offre, attraverso il nostro marketplace online, un'ampia gamma di videogiochi, codici digitali, carte regalo, punti per giochi e carte di abbonamento. Tutti i prodotti sono destinati esclusivamente all'uso personale e non alla rivendita. Ci approvvigioniamo presso editori e distributori autorizzati di terze parti. Tutti i nomi di prodotti, loghi e marchi menzionati sul nostro sito appartengono ai rispettivi proprietari e l'utilizzo di tali prodotti può essere soggetto a ulteriori condizioni di terzi, come i contratti di licenza d'uso finale per software di gioco. Bigswiss GmbH è un rivenditore indipendente e non è affiliata con gli editori di giochi o i fornitori di piattaforme salvo quanto dichiarato espressamente. L'acquisto di un prodotto ti conferisce il diritto di utilizzarlo secondo i termini dell'editore, senza trasferimento di diritti di proprietà intellettuale.",
      },
      section3: {
        title: "3. Ordering, Pricing, and Payment Terms",
        p1: "To purchase a product, you must follow the instructions on our website's checkout page. Ensure that all information you provide, such as your name, billing details, and delivery address, is accurate and complete. All prices are listed in Swiss Francs (CHF), and unless otherwise indicated, transactions will be processed in CHF. Prices include any applicable taxes, including VAT, unless stated otherwise at checkout. If you are using a payment method in a different currency, your bank or card issuer may apply currency conversion rates and fees, for which you are responsible.",
        p2: "Payment authorisation: When you confirm payment, we place an authorisation on your chosen payment method. We only capture the funds after your order passes mandatory fraud and compliance checks, which may include identity verification (KYC) before fulfilment. All payments are processed securely through vetted third-party payment service providers acting on our behalf, and Bigswiss GmbH remains the legal counterparty on your receipt or card statement.",
        p3: "Additional verification: We may ask you to submit supporting documents such as proof of address, government-issued identification, or a facial verification selfie so that our providers can authenticate the purchaser and protect against fraud. By placing an order you agree that we may share the strictly necessary data with our authorised payment and identity partners for these checks.",
        p4: "Payments are authorised at checkout and captured only after required fraud screening and, where applicable, identity verification. If verification is not completed, declined, or fails, we may cancel the order and release the authorisation without charge. We reserve the right to refuse or cancel any order we suspect of unauthorised or fraudulent activity, as further described in Section 7.",
        p5: "Third-party services: We rely on authorised third-party payment processors and fraud-prevention providers to process payments, validate transactions, and secure our platform. We only share the information necessary for them to perform these services, and every transaction is subject to their validation and authorisation checks.",
        p6: "Order acceptance: We may refuse, pause, or cancel an order if we suspect fraud, unauthorised use, or a breach of these Terms. We may also request additional information — including identity verification — before accepting or fulfilling an order.",
      },
      section4: {
        title: "4. Consegna di prodotti digitali e fisici",
        p1: "Prodotti digitali: per beni digitali come codici di giochi, codici di carte regalo o abbonamenti digitali, la consegna avviene in formato elettronico. Dopo la conferma del pagamento, il prodotto digitale, ad esempio un codice o una chiave di licenza, ti verrà inviato tramite e-mail o reso disponibile nel tuo account Bigswiss. Tempi di consegna: nella maggior parte dei casi la consegna è immediata o avviene entro pochi minuti dall'acquisto. In rari casi la consegna può richiedere fino a 24 ore, ad esempio se è necessario un controllo manuale per prevenire frodi. Se non ricevi il prodotto digitale entro i tempi previsti, controlla la cartella spam o posta indesiderata e contatta poi il nostro supporto.",
        p2: "Prodotti fisici: quando offriamo prodotti fisici, come carte regalo stampate o merchandising, questi vengono spediti all'indirizzo di consegna da te indicato. Al momento consegniamo prodotti fisici in Svizzera e in alcune destinazioni internazionali specificate nella pagina del prodotto o durante il checkout. Se il tuo ordine è idoneo alla consegna internazionale, i paesi disponibili saranno mostrati durante il checkout. I tempi di consegna dei prodotti fisici variano in base alla destinazione: in Svizzera la spedizione richiede generalmente da 3 a 5 giorni lavorativi; per destinazioni internazionali può richiedere da 7 a 14 giorni lavorativi o più, a seconda del luogo. Tieni presente che tali tempi sono stime e non garanzie, poiché possono verificarsi ritardi dovuti ai servizi postali o alle procedure doganali.",
        p3: "Per ogni spedizione fisica, eventuali costi di spedizione e i dettagli del corriere ti saranno comunicati durante il checkout. Condizioni di consegna: faremo il possibile per spedire i prodotti nei tempi indicati. Comprendi tuttavia che la consegna può essere influenzata da fattori fuori dal nostro controllo, come ritardi del corriere o lo sdoganamento per spedizioni internazionali. La proprietà e il rischio di perdita dei beni fisici passano a te al momento della consegna all'indirizzo fornito. Assicurati che qualcuno sia disponibile per ritirare il pacco. Se un pacco ci viene restituito a causa di un indirizzo errato o della mancata consegna, ti contatteremo per organizzare una nuova spedizione; potrebbero essere applicati costi aggiuntivi.",
      },
      section5: {
        title: "5. Politica di reso, rimborso e cancellazione",
        p1: "Resi e rimborsi: desideriamo che tu sia soddisfatto del tuo acquisto. Se un prodotto non ti soddisfa pienamente, puoi richiedere un reso o un rimborso entro 7 giorni dall'acquisto, periodo che definiamo finestra di reso. Offriamo una politica di reso semplice: entro 7 giorni dalla data di ricezione del prodotto, o dalla data di acquisto per i beni digitali, puoi restituire l'articolo per ottenere un rimborso completo o un cambio.",
        p2: "- Prodotti digitali: il codice non deve essere stato riscattato né utilizzato. Ci riserviamo il diritto di verificare se un codice digitale sia stato attivato. Se il codice risulta inutilizzato, lo disattiveremo e ti emetteremo un rimborso o forniremo un prodotto sostitutivo secondo la tua richiesta. Se il prodotto digitale risulta difettoso, ad esempio un codice non funzionante, contattaci subito: forniremo un codice valido o rimborseremo l'acquisto.",
        p3: "- Prodotti fisici: l'articolo deve essere restituito nelle condizioni originali, non utilizzato e con l'imballo e gli accessori inclusi. Per avviare un reso, contatta il nostro supporto entro 7 giorni dalla consegna per ricevere le istruzioni. Potrebbe esserti richiesto di rispedirci l'articolo. Dopo aver ricevuto il prodotto in condizioni accettabili, procederemo con il rimborso o con l'invio di un prodotto sostitutivo, in base alle tue preferenze. Salvo errore da parte nostra o difetto del prodotto, i costi di spedizione del reso potrebbero essere a tuo carico.",
        refundPrefix: "Come richiedere un rimborso o un reso: contatta il nostro servizio clienti via e-mail all'indirizzo",
        refundSuffix: "entro 7 giorni. Indica il numero dell'ordine, il prodotto che desideri restituire e, facoltativamente, la motivazione. Il nostro team di supporto ti guiderà durante il processo. I rimborsi approvati saranno accreditati sul metodo di pagamento originale in genere entro 5-10 giorni lavorativi dall'approvazione. Riceverai un'e-mail di conferma quando il rimborso sarà stato elaborato. Se hai richiesto una sostituzione, spediremo il prodotto alternativo il prima possibile e i tempi di consegna saranno simili a quelli di un nuovo ordine.",
        cancellationPrefix: "Politica di cancellazione: se desideri annullare un ordine prima che sia completato o consegnato, contattaci immediatamente all'indirizzo",
        cancellationSuffix: ". Possiamo annullare il tuo ordine ed emettere un rimborso completo se l'ordine è ancora in lavorazione e il prodotto non è stato consegnato. Per i beni digitali questo significa che il codice non è stato ancora mostrato o inviato; per i beni fisici, che il pacco non è stato ancora spedito. Una volta che un codice digitale è stato consegnato o un ordine fisico è stato spedito, in genere non possiamo più annullare l'ordine, ma puoi comunque richiedere un reso o un rimborso come descritto sopra. Nel caso di preordini o ordini arretrati, se applicabile, puoi annullare e ottenere un rimborso completo in qualsiasi momento prima della consegna.",
        p6: "Importante: ci riserviamo il diritto di rifiutare un reso o un rimborso, o di imporre condizioni aggiuntive, se sospettiamo un abuso della nostra politica di reso. Ad esempio, richieste di reso eccessive, la dichiarazione di un codice digitale già utilizzato come 'non utilizzato' o altri comportamenti fraudolenti o disonesti possono comportare il rifiuto di rimborsi, l'annullamento di ordini e la chiusura del tuo account, come previsto dalla Sezione 7. Il nostro obiettivo è agire in modo equo e flessibile entro la finestra di 7 giorni.",
      },
      section6: {
        title: "6. Divieto di rivendita",
        p1: "I prodotti acquistati da Bigswiss sono destinati esclusivamente all'uso personale. La rivendita di codici digitali, carte regalo o altri prodotti ottenuti tramite Bigswiss GmbH è espressamente vietata. Qualsiasi tentativo di acquistare prodotti per rivenderli commercialmente, o di rivendere, redistribuire o trasferire i nostri prodotti a terzi senza il nostro esplicito consenso, costituisce una violazione dei presenti Termini. Se determiniamo che rivendi prodotti acquistati da noi, o acquisti per conto di altri a fini di rivendita, ci riserviamo il diritto di intervenire. Ciò può includere la chiusura immediata del tuo account, l'annullamento degli ordini in sospeso e il rifiuto di fornirti servizi futuri. Ci riserviamo inoltre il diritto di intraprendere azioni legali contro persone o entità che effettuano rivendite non autorizzate. Acquistando da Bigswiss accetti di non rivendere né distribuire i prodotti a fini commerciali.",
      },
      section7: {
        title: "7. Frodi e attività non autorizzate",
        p1: "Ci impegniamo a offrire un marketplace sicuro e protetto. Le attività fraudolente o illegali sono severamente vietate sul nostro sito. Accetti di non impegnarti in pratiche ingannevoli o non autorizzate, tra cui, a titolo esemplificativo, l'uso di metodi di pagamento rubati o non autorizzati, il tentativo di manipolare transazioni o prezzi, la creazione di più account per sfruttare promozioni o qualsiasi forma di frode di pagamento o furto d'identità. Ci riserviamo il diritto di annullare qualunque ordine e di sospendere o chiudere il tuo account senza preavviso qualora sospettassimo frodi, uso non autorizzato dei nostri servizi o violazioni di legge o dei presenti Termini.",
        p2: "Se il tuo account viene chiuso per frode o uso improprio, potresti non poter più registrarti o accedere ai nostri servizi in futuro. Collaboriamo con le autorità e con i fornitori di servizi di pagamento in caso di sospetto di frode o attività illegale. Qualsiasi comportamento fraudolento può comportare azioni legali.",
        p3: "Devi inoltre astenerti da qualsiasi utilizzo improprio del nostro sito web, inclusa l'introduzione deliberata di virus, il tentativo di ottenere accesso non autorizzato al sito o a sistemi correlati o l'esecuzione di attacchi come quelli di tipo denial-of-service. Tali azioni sono illegali e saranno segnalate alle autorità, e intraprenderemo le azioni legali appropriate.",
      },
      section8: {
        title: "8. Diritti di proprietà intellettuale",
        p1: "Tutti i contenuti e i materiali presenti sul sito Bigswiss — inclusi testi, grafica, loghi, icone, immagini, clip audio e software — sono di proprietà di Bigswiss GmbH o dei rispettivi fornitori di contenuti e sono protetti dalle leggi sulla proprietà intellettuale. Non è consentito copiare, distribuire, modificare o creare opere derivate dal contenuto del nostro sito senza il nostro previo consenso scritto, salvo quanto consentito dalla legge. Puoi copiare o stampare porzioni del sito per uso personale quando valuti o acquisti prodotti Bigswiss, ma qualsiasi altro utilizzo dei contenuti è vietato.",
        p2: "Come indicato nella Sezione 2, i prodotti che vendiamo, come videogiochi, codici digitali e carte regalo, possono includere proprietà intellettuale di terzi. Tutti i marchi, marchi di servizio, nomi di prodotti e loghi associati ai prodotti sono di proprietà dei rispettivi titolari. Nulla nei presenti Termini ti conferisce il diritto di utilizzare marchi o elementi distintivi di Bigswiss o di terzi.",
        p3: "Quando acquisti e utilizzi prodotti di terze parti, ad esempio un codice di attivazione per giochi o una carta di abbonamento, accetti di rispettare gli accordi di licenza con l'utente finale, i termini d'uso o altre condizioni imposte da tali fornitori. Bigswiss non è responsabile dei termini di servizio o delle pratiche sulla privacy delle piattaforme di terzi come Steam, Xbox o PlayStation Network. Se hai domande sui termini di terze parti applicabili a un prodotto, consulta la documentazione fornita dall'editore o dal fornitore.",
      },
      section9: {
        title: "9. Privacy e protezione dei dati",
        p1: "La tua privacy è importante per noi. La raccolta e l'utilizzo dei dati personali in relazione all'uso del nostro sito web e dei nostri servizi sono descritti nella nostra Informativa sulla privacy, che è incorporata nei presenti Termini per riferimento. Puoi consultare l'Informativa completa sul nostro sito, tramite il link disponibile nel footer. Utilizzando i nostri servizi, dichiari di aver letto l'Informativa sulla privacy e acconsenti alla raccolta e all'utilizzo dei tuoi dati come descritto.",
        p2: "In sintesi, quando utilizzi Bigswiss possiamo raccogliere dati personali come nome, recapiti, indirizzo di spedizione, e-mail, informazioni di pagamento e credenziali dell'account. Proteggiamo tali informazioni e le utilizziamo per elaborare gli ordini, consegnare i prodotti, fornire assistenza clienti e migliorare i nostri servizi. Condividiamo solo i dati necessari con terze parti di fiducia che ci aiutano a fornire i servizi: ad esempio condividiamo i dettagli di pagamento con i processori di pagamento per addebitare la tua carta e prevenire le frodi, il tuo indirizzo di consegna con i partner di spedizione per recapitare i beni fisici e, se necessario, il tuo indirizzo e-mail con i fornitori di servizi di posta elettronica per inviare le conferme d'ordine. Non vendiamo i tuoi dati personali a terzi non collegati. Tuttavia, se richiesto dalla legge o per far rispettare i presenti Termini, possiamo divulgare informazioni alle autorità, come indicato nella nostra Informativa sulla privacy.",
        p3: "Cookie: il nostro sito utilizza cookie e tecnologie simili per migliorare l'esperienza dell'utente, ricordare le tue preferenze e analizzare il traffico. Per maggiori dettagli sui tipi di cookie utilizzati e sulle tue opzioni, consulta l'Informativa sulla privacy e la Politica sui cookie. Utilizzando il nostro sito accetti l'uso dei cookie come descritto in tali politiche.",
        p4: "Se hai domande sul trattamento dei tuoi dati o desideri esercitare i diritti in materia di protezione dei dati, come l'accesso o la cancellazione delle informazioni, consulta l'Informativa sulla privacy o contattaci all'indirizzo e-mail indicato nella sezione Informazioni di contatto di seguito.",
      },
      section10: {
        title: "10. Esclusione di garanzie",
        p1: "Bigswiss GmbH fornisce il sito web e tutti i prodotti 'così come sono' e 'secondo disponibilità'. Nei limiti consentiti dalla legge, escludiamo ogni garanzia espressa o implicita riguardante i nostri servizi e i prodotti acquistati tramite noi, incluse, a titolo esemplificativo, le garanzie implicite di commerciabilità, idoneità a uno scopo particolare, titolarità e assenza di violazioni. Non garantiamo che il sito funzioni ininterrottamente o senza errori, né che i prodotti soddisfino le tue aspettative oltre quanto espressamente descritto sul nostro sito.",
        p2: "Pur impegnandoci a garantire l'esattezza delle informazioni sui prodotti e il corretto funzionamento dei codici o degli articoli digitali consegnati, non possiamo assicurare che i prodotti siano privi di difetti. Ad esempio, non possiamo garantire che un gioco digitale o un servizio sia privo di bug o che i servizi online gestiti da terzi siano sempre disponibili. Eventuali garanzie o assistenza relative al gioco o ai contenuti digitali acquistati sono di norma fornite dall'editore o dal produttore del prodotto, non da Bigswiss. Garantiamo tuttavia che ogni codice digitale venduto sia valido e riscattabile; in caso contrario forniremo un codice funzionante o rimborseremo l'acquisto secondo la nostra politica di reso. Al di là di tale rimedio, l'uso dei prodotti avviene a tuo rischio.",
        p3: "Alcune giurisdizioni non consentono l'esclusione di determinate garanzie, pertanto alcune delle esclusioni sopra indicate potrebbero non applicarsi a te. In tali casi, eventuali garanzie previste dalla legge si limitano al periodo più breve e all'estensione massima consentiti.",
      },
      section11: {
        title: "11. Limitazione di responsabilità",
        p1: "Nei limiti consentiti dalla legge applicabile, Bigswiss GmbH non sarà responsabile per danni indiretti, incidentali, speciali, consequenziali o punitivi derivanti dall'uso del nostro sito o dall'acquisto di qualsiasi prodotto. Ciò include, senza limitazione, la perdita di profitti o ricavi, la perdita di dati, la perdita di avviamento o altre perdite immateriali, anche se siamo stati informati della possibilità di tali danni.",
        p2: "La nostra responsabilità complessiva nei tuoi confronti per tutte le pretese derivanti da questi Termini o dall'uso dei nostri servizi è limitata all'importo pagato per il prodotto o i prodotti interessati. Ad esempio, se hai acquistato un codice di gioco e presenti un reclamo relativo a tale acquisto, la nostra responsabilità non supererà il prezzo da te pagato per quel codice.",
        p3: "Bigswiss non è responsabile per ritardi o mancata esecuzione dovuti a cause al di fuori del nostro ragionevole controllo, come eventi di forza maggiore, guerra, terrorismo, attacchi informatici, disastri naturali, epidemie, ordini governativi o guasti dei fornitori di telecomunicazioni o di servizi Internet. Tali eventi di forza maggiore sospendono i nostri obblighi nella misura consentita dalla legge.",
        p4: "Nulla in questi Termini limita o esclude la nostra responsabilità per colpa grave, dolo o per qualsiasi responsabilità che non possa essere esclusa o limitata dalla legge, ad esempio alcune obbligazioni previste dal diritto svizzero o dalla normativa di tutela dei consumatori dell'UE. In ogni caso la nostra responsabilità è limitata a quanto imposto dalla legge.",
        p5: "Accetti di utilizzare i servizi Bigswiss a tuo rischio. Se non sei soddisfatto di un qualsiasi aspetto del nostro servizio o di questi Termini, il tuo unico ed esclusivo rimedio consiste nel interrompere l'uso del servizio o, quando applicabile, avvalerti della nostra politica di reso o rimborso.",
      },
      section12: {
        title: "12. Legge applicabile e foro competente",
        p1: "I presenti Termini e qualunque controversia o pretesa che ne derivi o ad essi si riferisca, incluse le controversie extracontrattuali, sono regolati e interpretati in conformità al diritto svizzero, senza riguardo ai relativi principi sul conflitto di leggi. In qualità di consumatore, beneficerai anche di tutte le tutele obbligatorie riconosciute dalla legge del tuo paese di residenza.",
        p2: "Eventuali controversie che non possiamo risolvere in via amichevole rientrano nella competenza esclusiva dei tribunali svizzeri. In particolare, salvo diversa disposizione di legge, accetti che qualsiasi azione o procedimento derivante dai presenti Termini sia proposto presso i tribunali competenti del Cantone San Gallo, Svizzera, dove ha sede Bigswiss GmbH. Tu e Bigswiss accettate la giurisdizione personale di tali tribunali.",
        p3: "Se sei un consumatore residente al di fuori della Svizzera, potresti avere il diritto di avviare procedimenti nel tuo paese di residenza in virtù di specifiche leggi di protezione dei consumatori. I presenti Termini non limitano alcun diritto che non possa essere rinunciato contrattualmente.",
      },
      section13: {
        title: "13. Informazioni di contatto",
        p1: "Per qualsiasi domanda, dubbio o commento riguardante questi Termini o i nostri servizi, contattaci. I nostri recapiti ufficiali sono i seguenti:",
        p2: "Nome della società: Bigswiss GmbH (n. di registrazione CHE-361.327.609)",
        p3: "Indirizzo registrato: Lerchenstrasse 30, 9200 Gossau, San Gallo, Svizzera",
        emailLabel: "Indirizzo e-mail:",
        emailNote: "(per richieste di assistenza clienti)",
        p4: "Puoi anche contattarci tramite il modulo presente nella pagina 'Contattaci' del nostro sito web. Faremo il possibile per rispondere a tutte le richieste entro 2 giorni lavorativi.",
        p5: "Grazie per aver letto i nostri Termini e Condizioni. Utilizzando il sito e i servizi di Bigswiss dichiari di comprendere e accettare questi Termini. Apprezziamo la tua fiducia e ci impegniamo a offrire a tutti un'esperienza di acquisto sicura e piacevole. Se hai bisogno di ulteriori chiarimenti su questi Termini, non esitare a contattarci. Buon divertimento!",
      },
    },
    privacyPage: {
      seoTitle: "Privacy Policy - Bigswiss GmbH",
      seoDescription:
        "Learn how Bigswiss GmbH collects, uses, and protects personal data across our digital store, wholesale tools, API integrations, and kiosk applications.",
      heading: "Privacy Policy",
      lastUpdated: "Last Updated: October 4, 2025",
      section1: {
        p1: "Bigswiss GmbH ('Bigswiss', 'we', 'us', or 'our') is committed to protecting your personal information and respecting your privacy across every channel where we operate.",
        p2: "This Privacy Policy describes the types of data we collect, how we use and share it, and the choices you have when you access our online store, wholesale portal, kiosk applications, or API services.",
      },
      section2: {
        title: "1. Data We Collect",
        p1: "We collect personal information that you provide directly to us, such as your name, contact details, delivery addresses, order history, and payment information when you create an account, place an order, or interact with support.",
        p2: "For compliance and fraud-prevention purposes we may also collect identity documentation, facial images or biometric templates generated during verification, proof-of-address materials, and records of the consent you grant for those checks.",
        p3: "We additionally receive technical and behavioural signals — for example device identifiers, browser or device fingerprints, IP addresses, authentication logs, API calls, and transaction risk scores — to help secure payments and detect abuse. Some of this data is supplied by our authorised payment and risk partners when you begin checkout.",
      },
      section3: {
        title: "2. How We Use Your Data",
        intro: "We process personal data only when we have a lawful basis and for the purposes described below:",
        items: [
          "Processing orders, delivering digital or physical products, and providing customer support.",
          "Personalising content, language, and currency preferences across our storefronts.",
          "Communicating about purchases, account updates, and optional marketing you agree to receive.",
          "Monitoring platform performance, troubleshooting issues, and improving product offerings.",
          "Verifying identity to meet anti-fraud, Know Your Customer (KYC), and anti-money-laundering obligations (based on your explicit consent and applicable legal requirements).",
          "Detecting, investigating, and preventing fraud, abuse, or security incidents in our legitimate interests and to perform our contract with you.",
          "Maintaining the records required for tax, financial, and regulatory compliance, including documenting when and how you granted or withdrew consent.",
        ],
      },
      section4: {
        title: "3. Payment Processing & Fraud Prevention",
        intro:
          "When you make a purchase, we process your payment through authorised third-party payment processors and rely on fraud-prevention providers to protect transactions. We may share:",
        items: [
          "Name, contact details, billing and delivery addresses so your order can be fulfilled.",
          "Payment account details (masked card tokens, wallet identifiers) together with the order amount, currency, and history.",
          "Device and network identifiers such as IP address, browser or device fingerprints, and session telemetry used to authenticate the transaction.",
          "Any additional information required to verify the transaction or comply with financial regulations.",
        ],
        footer:
          "Purpose & legal basis: fulfil your order (contract), prevent fraud and secure our services (legitimate interests), and comply with legal obligations where applicable. These providers are contractually bound to use your data only for these purposes and to protect it under industry-standard safeguards. We do not store full card numbers or CVV on our systems.",
      },
      section5: {
        title: "4. Identity Verification & Biometric Information",
        p1: "For certain transactions we may ask you to complete identity verification so we can satisfy compliance and anti-fraud obligations.",
        p2: "Verification can include document checks and, if you agree, biometric verification such as facial image matching. We will only collect or use biometric data with your explicit consent at the time of verification and use it solely for identity verification and fraud prevention.",
        p3: "Biometric data is encrypted and retained only as long as necessary to complete verification or as required by law, after which it is deleted or anonymised. If you do not wish to undergo biometric verification, contact support to discuss available alternatives.",
      },
      section6: {
        title: "5. When We Share Data",
        intro: "We disclose personal data only when necessary and subject to appropriate safeguards:",
        items: [
          "With trusted third-party payment processors and identity verification partners who help us authorise payments, run fraud screening, and perform KYC checks (they receive only the minimum data required).",
          "With logistics, fulfilment, and digital distribution partners so orders can be delivered and entitlements validated.",
          "With professional advisers, auditors, banks, or insurers where required for legal, compliance, or accounting purposes.",
          "With regulators, competent authorities, or law enforcement when we are legally required to do so or to protect the rights and safety of Bigswiss, our users, or others.",
          "In connection with a corporate transaction, such as a merger or acquisition, where permitted by law and subject to appropriate safeguards.",
        ],
      },
      section7: {
        title: "6. International Data Transfers",
        p1: "Your information may be stored and processed in Switzerland, the European Economic Area, the United Kingdom, or other countries where we or our vetted service providers operate. Whenever data leaves Switzerland or the EEA/UK, we rely on recognised safeguards such as Standard Contractual Clauses or the UK International Data Transfer Addendum to protect your rights.",
      },
      section8: {
        title: "7. Data Retention",
        p1: "We keep personal data only as long as necessary to fulfil the purposes described in this Policy, comply with legal obligations, resolve disputes, and enforce agreements. Payment and order records are typically retained for up to ten years under Swiss and EU accounting rules. Biometric and identity verification evidence is stored for the shorter of the applicable regulatory retention period or five years, after which it is securely deleted or irreversibly anonymised unless a longer period is mandated by law.",
      },
      section9: {
        title: "8. Cookies and Tracking Technologies",
        p1: "We use cookies, SDKs, and similar technologies to remember your preferences, keep sessions secure, analyse site usage, and support payment risk checks such as device fingerprinting. This may involve a data collection script loaded from an authorised provider during checkout. Non-essential analytics, advertising, and risk-detection cookies only run when you grant consent through the controls provided in our interfaces.",
      },
      section10: {
        title: "9. Your Rights",
        p1: "Depending on your location, you may have rights to access, correct, delete, or restrict the processing of your personal data, to receive a copy of your data in portable format, and to object to processing carried out on legitimate-interest grounds.",
        p2: "Where we rely on your consent (for example for biometric KYC checks or optional cookies) you may withdraw that consent at any time; this does not affect the lawfulness of processing before withdrawal but may prevent us from completing an order that requires verification.",
        p3: "Contact our privacy team at privacy@bigswiss.ch or at our postal address to exercise these rights or raise a concern.",
        p4: "If you are located in the EU, you can contact your local supervisory authority or the Swiss Federal Data Protection and Information Commissioner; UK residents can contact the Information Commissioner's Office. We will provide guidance on how to reach the appropriate authority upon request.",
      },
      section11: {
        title: "10. Automated Fraud Decisions",
        p1: "We use automated tools to assess transaction risk. If a transaction is declined solely due to automated processing and you are in the EU or UK, you may request human review and contest the decision.",
      },
      section12: {
        title: "11. Security Measures",
        p1: "We apply administrative, technical, and organisational safeguards to protect personal data, including encryption of credentials, secure storage of identity documents, restricted access controls, secure payment processing through trusted providers, and network protection delivered by partners such as Cloudflare. No system is entirely immune from risk, but we regularly review our defences to keep your information safe.",
      },
      section13: {
        title: "12. California Privacy Rights",
        p1: "We do not sell personal information. We use sensitive personal information (such as payment details) only to provide requested services and to prevent fraud; therefore, the California Privacy Rights Act right to limit does not apply to our current use. California residents can exercise access, deletion, correction, and other rights via the contact methods listed in this Policy.",
      },
      section14: {
        title: "13. Updates to This Policy",
        p1: "We may update this Privacy Policy to reflect operational, legal, or regulatory changes. We will post the revised version with a new 'Last Updated' date, and we encourage you to review it periodically.",
      },
      section15: {
        title: "14. Contact Us",
        p1: "If you have questions about this Privacy Policy or how Bigswiss handles your data, contact our Data Protection Officer at privacy@bigswiss.ch.",
      },
    },
  auth: {
    errors: {
      invalidCredentials:
        "L'e-mail o la password inserita non è corretta.",
      weakPassword:
        "Scegli una password più sicura che soddisfi i requisiti minimi.",
      alreadyExists:
        "Esiste già un account con questa e-mail. Accedi oppure usa un'altra e-mail.",
      emailAlreadyTakenHint:
        "Email già utilizzata. Scegli un altro indirizzo e-mail oppure reimposta la tua password.",
      generic: "Si è verificato un errore. Riprova.",
    },
  },
  settingsPage: {
    userSettingsUpdated: "Impostazioni aggiornate correttamente. Effettua di nuovo l'accesso.",
    failedToUpdateUserSettings: "Impossibile aggiornare le impostazioni",
  },
  passwordsDoNotMatch: "Le password non coincidono",
  passwordUpdatedSuccessfully: "Password aggiornata con successo",
  passwordUpdateFailed: "Aggiornamento della password non riuscito",
  socialAccounts: "Account social",
  connectSocialAccounts: "Collega i tuoi account social per accedere rapidamente con le tue piattaforme preferite.",

  selectCurrency: "Seleziona la valuta",
  newsletter: "Notiziario",
  subscribeMessage:
    "Iscriviti alla nostra newsletter per aggiornamenti settimanali e promozioni.",
  subscribe: "Iscriviti",
  products: "Prodotti",
  suggestedProducts1: "Prodotti",
  suggestedProducts2: "Suggeriti",
  product: "Prodotto",
  languages: "Lingue",
  language: "Lingua",
  menu: "Menu",
  audio: "Audio",
  subtitles: "Sottotitoli",
  position: "Posizione",
  message: "Messaggio",
  invalidEmail: "E-mail non valida",
  allFieldsRequired: "Si prega di compilare tutti i campi obbligatori",
  messageSent: "Messaggio inviato",
  contacted: "Richiesta inviata",
  jobThankYou: "Grazie per il vostro interesse. Vi contatteremo presto.",
  duplicateApplication:
    "Hai già fatto domanda, ti preghiamo di pazientare fino a quando non ti contatteremo.",
  duplicateSubscription: "Sei già iscritto.",
  succesSubcribed: "Ti sei iscritto con successo.",
  company: "Azienda",
  getInTouch: "Mettersi in contatto",
  privacyPolicy: "Politica sulla riservatezza",
  termsOfService: "Termini di servizio",
  pcGames: "Giochi per PC",
  xboxGames: "Giochi XBOX",
  playstationGames: "Giochi PlayStation",
  nintendoGames: "Giochi Nintendo",
  giftCards: "Carte regalo",
  subscriptionCards: "Carte di abbonamento",
  aboutUs: "Chi siamo",
  testimonials: "Testimonianze",
  testimonialsDescription:
    "Scopri cosa amano i nostri clienti delle nostre funzionalità. Scopri come eccelliamo in efficienza e soddisfazione. Unisciti a noi per costi ridotti, innovazione nel retail e supporto affidabile.",

  highlights: "Punti salienti",
  pricing: "Prezzi",

  faqs: "FAQ",
  giftAndSubscriptionCards: "Carte regalo & di abbonamento",
  checkTopSellers: "Controlla i più venduti",
  platforms: "Piattaforme",
  category: "Categoria",
  platform: "Piattaforma",
  contactSupportText:
    "Se desideri cambiare la regione del tuo account, contatta il nostro supporto",
  region: "Regione",
  productType: "Tipo di prodotto",
  none: "Nessuno",
  sort: "Ordina",
  priceIncreasing: "Aumento del prezzo",
  priceDecreasing: "Diminuzione del prezzo",

  consoles: "Console",
  aboutUsDescription:
    "Dal 2002, Bigswiss.ch è la tua destinazione di riferimento per giochi digitali e carte regalo, operando orgogliosamente dal cuore della Svizzera. Con oltre due decenni di esperienza, ci impegniamo a offrirti il meglio del mondo dell'intrattenimento digitale.\n\nLa nostra vasta selezione include una grande varietà di giochi digitali su tutte le piattaforme popolari, oltre a una gamma di carte regalo per i tuoi servizi preferiti. Che tu sia un giocatore esperto in cerca della prossima grande uscita o alla ricerca del regalo perfetto per una persona cara, Bigswiss.ch ha tutto ciò di cui hai bisogno.\n\nSu Bigswiss.ch, siamo orgogliosi di offrire un servizio clienti eccezionale e un'esperienza di acquisto senza soluzione di continuità. Il nostro team dedicato è sempre a tua disposizione per assisterti, assicurandoti che il tuo viaggio con noi sia piacevole e senza intoppi.",
  onlineStoreTitle: "Negozio online",
  onlineStoreDescription:
    "Acquista oltre 10.000 videogiochi e prodotti digitali diversi",
  posTerminalsTitle: "Terminali POS",
  posTerminalsDescription:
    "Integra i nostri terminali POS nel tuo negozio e accedi a tutti i nostri giochi",
  wholesaleApiTitle: "API all'ingrosso",
  wholesaleApiDescription:
    "Integra la nostra API all'ingrosso nel tuo negozio online",
  learnMore: "Scopri di più",
  goToStore: "Vai al negozio",
  highlightsDescription:
    "Scopri perché il nostro prodotto si distingue: adattabilità, durata, design intuitivo e innovazione. Goditi un supporto clienti affidabile e una precisione in ogni dettaglio.",

  securePaymentsTitle: "Pagamenti sicuri",
  securePaymentsDescription: "Goditi transazioni sicure e protette.",
  officialKeysTitle: "Chiavi ufficiali",
  officialKeysDescription: "Chiavi ottenute da editori ufficiali per garantire la loro autenticità.",

  FoundYour: "Trova Il",
  FavoriteGenre: "Genere Preferito?",

  instantDeliveryTitle: "Consegna Istantanea",
  instantDeliveryDescription:
    "Ricevi i tuoi codici digitali immediatamente dopo l'acquisto.",
  digitalDownloadTitle: "Download Digitale",
  digitalDownloadDescription:
    "Accedi ai tuoi giochi e servizi preferiti con codici facili da riscattare.",
  customerSupportTitle: "Supporto Clienti 24/7",
  customerSupportDescription:
    "Siamo qui per te in qualsiasi momento, pronti a risolvere qualsiasi problema.",
  adaptablePerformanceTitle: "Prestazioni Adattabili",
  adaptablePerformanceDescription:
    "Il nostro prodotto si adatta facilmente alle tue esigenze, aumentando l'efficienza e semplificando i tuoi compiti.",
  innovativeFunctionalityTitle: "Funzionalità Innovativa",
  innovativeFunctionalityDescription:
    "Rimani all'avanguardia con funzionalità che stabiliscono nuovi standard, rispondendo meglio alle tue esigenze in evoluzione.",
  precisionDetailTitle: "Precisione in ogni dettaglio",
  precisionDetailDescription:
    "Goditi un prodotto meticolosamente realizzato in cui i piccoli dettagli hanno un impatto significativo sulla tua esperienza complessiva.",
  ourTopSellingProducts: "I nostri prodotti più venduti",

  faqTitle: "Domande frequenti",
  faq1Question:
    "Come posso contattare l'assistenza clienti se ho una domanda o un problema?",
  faq1Answer:
    "Siamo qui per assisterti prontamente. Puoi contattare il nostro team di assistenza clienti inviando un'email a ",
  faq2Question:
    "Posso restituire il prodotto se non soddisfa le mie aspettative?",
  faq2Answer:
    "Assolutamente! Offriamo una politica di restituzione senza problemi. Se non sei completamente soddisfatto, puoi restituire il prodotto entro 7 giorni per un rimborso completo o uno scambio.",
  faq3Question:
    "Cosa rende il vostro prodotto diverso dagli altri sul mercato?",
  faq3Answer:
    "Il nostro prodotto si distingue per la sua adattabilità, durata e caratteristiche innovative. Prioritizziamo la soddisfazione dell'utente e ci sforziamo continuamente di superare le aspettative in ogni aspetto.",
  faq4Question: "C'è una garanzia sul prodotto e cosa copre?",
  faq4Answer:
    "Sì, il nostro prodotto viene fornito con una garanzia di 1 anno. Copre i difetti di materiali e di lavorazione. Se riscontri problemi coperti dalla garanzia, contatta il nostro servizio clienti per assistenza.",

  available: "Disponibile",
  now: "Ora",
  games: "Giochi",
  about: "Informazioni su",
  game: "Gioco",
  website: "Sito web",
  description: "Descrizione",
  rating: "Valutazione",
  developer: "Sviluppatore",
  publisher: "Editore",
  released: "Data di rilascio",
  genre: "Genere",
  gallery: "Galleria",
  maxPrice: "Prezzo massimo",

  availableEditions: "Edizioni Disponibili",
  availablePlatforms: "Piattaforme Disponibili",
  addToCart: "Aggiungi al carrello",
  outOfStock: "Esaurito",
  emptyCartHeading: "Il carrello è vuoto...",
  emptyCartSubheading:
    "Il tuo carrello desidera compagnia. Inizia ora la tua avventura di shopping!",
  exploreCatalog: "Esplora il nostro catalogo",
  yourCart: "Il tuo Carrello",
  quantity: "Quantità",
  maxProductAllowed: "Massimo di {{max}} prodotti consentiti",
  total: "Totale",
  goToCart: "Vai al Carrello",
  payNow: "Paga ora",
  goToPayment: "Vai al Pagamento",
  discount: "Sconto",
  originalPrice: "Prezzo originale",
  checkMoreProducts: "Vedi più prodotti",
  cartSummary: "Riepilogo del carrello",
  cartItems: "Articoli nel carrello",
  payment: "Pagamento",
  gameActivation: "Attivazione del gioco",
  login: "Accesso",
  remove: "Rimuovere",

  Notification: "Notifica",
  notificationsEnabled: "Le notifiche del browser sono abilitate",
  notificationsEnableFail: "Impossibile abilitare le notifiche",
  notificationsDisabled: "Le notifiche del browser sono disabilitate",
  notificationsDisableFail: "Impossibile disabilitare le notifiche",
  notificationsDenied: "Permesso di notifica negato",
  notificationsNoPermission: "Permesso di notifica non concesso",
  notificationsPermissionFaild:
    "Richiesta di permesso di notifica non riuscita",
  notificationsNotSupported: "La messaggistica push non è supportata",
  notificationsFailToSubscribe: "Impossibile iscrivere l'utente",
  notificationsFailToUnsubscritbe: "Impossibile annullare l'iscrizione dell'utente",
  notificationsFailToUnsubscribe:
    "Impossibile annullare l'iscrizione dell'utente",
  serviceWorkerNotReady: "Si prega di ricaricare la pagina e riprovare",
  notificationsSubscriptionErro:
    "Errore durante l'ottenimento dell'abbonamento",
  browserNotifications: "Notifiche del browser",
  emailNotifications: "Avvisi e‑mail",
  smsNotifications: "Avvisi SMS",
  emailNotificationsEnabled: "Notifiche e‑mail abilitate",
  emailNotificationsDisabled: "Notifiche e‑mail disabilitate",
  smsNotificationsEnabled: "Notifiche SMS abilitate",
  smsNotificationsDisabled: "Notifiche SMS disabilitate",
  retry: "Riprova",
  pleaseTryAgainSoon: "Riprova tra qualche istante.",
  pleaseTryAgain: "Per favore riprova.",

  noProductsFound: "Nessun prodotto trovato.",
  tryDifferentQuery:
    "Si prega di provare una ricerca diversa o reimpostare i filtri.",
  resetFilters: "Reimposta filtri",
  achievements: "Successi",
  achievementsPage: {
    signInTitle: "Accedi per iniziare a guadagnare",
    signInDescription: "Accedi per iniziare a ottenere obiettivi, salire di livello e sbloccare sconti.",
    toastUnlocked: "{{title}} sbloccato!",
    loadingTitle: "Caricamento obiettivi",
    loadingSubheader: "Recupero dei tuoi progressi più recenti.",
    loadingWarming: "Preparazione registro missioni e statistiche referral...",
    errorCardSubheader: "Si è verificato un problema durante il caricamento dei dati.",
    errorTitle: "Obiettivi non disponibili",
    errorDetails: "{{details}} I tuoi obiettivi, livelli e dati referral sono temporaneamente non disponibili.",
    questErrorTitle: "Bacheca missioni offline",
    questErrorDetails: "Non siamo riusciti a caricare le ultime missioni. Premi Riprova per riprovare.",
    pointsAbbr: "pt",
    status: { locked: "Bloccato", unlocked: "Sbloccato", completed: "Completato", inProgress: "In corso" },
    prestige: {
      activateTitle: "Attiva Prestigio",
      title: "Prestigio",
      subheader: "Reimposta il tuo livello per cosmetici esclusivi e diritto di vanto.",
      body: "I livelli prestigio si sbloccheranno quando raggiungi il livello di fedeltà finale. Ogni prestigio reimposta il tuo livello e concede cosmetici e badge unici.",
      current: "Prestigio attuale: {{current}} / {{max}}",
      unavailable: "Prestigio non disponibile",
      activateButton: "Attiva Prestigio",
    },
    category: {
      purchases: "Traguardi di acquisto",
      spending: "Maestria di spesa",
      loyalty: "Ricompense fedeltà",
      community: "Comunità e social",
      engagement: "Booster di coinvolgimento",
    },
    level: {
      headerTitle: "Livello {{level}} • {{name}}",
      earned: "Guadagnati {{earned}} / {{total}} punti obiettivo",
      progressToNext: "Ottieni altri {{points}} punti obiettivo per sbloccare {{name}}.",
      maxed: "Hai raggiunto il livello di fedeltà massimo. Stato leggendario sbloccato!",
      current: "Livello attuale",
      next: "Successivo: {{name}}",
      maxedShort: "Massimo",
      legendUnlocked: "Leggenda sbloccata",
      target: "obiettivo",
      nextLevel: "Successivo: Livello {{level}}",
      maxLevel: "Livello massimo",
      showMore: "Mostra più statistiche",
      hideStats: "Nascondi statistiche extra",
      journeySnapshot: "Istante del percorso",
      progressToLevel: "Ottieni altri {{points}} punti obiettivo per raggiungere il Livello {{level}}.",
      allUnlocked: "Hai sbloccato tutti i livelli. Ricompense prestigio in arrivo.",
    },
    quests: {
      title: "Missioni",
      subheader: "Nuove sfide a rotazione giornaliera e settimanale",
      type: { daily: "Giornaliera", weekly: "Settimanale", seasonal: "Stagionale", event: "Evento", story: "Storia" },
      reward: "Ricompensa:",
      expiresIn: "Scade tra {{time}}",
      claim: "Riscatta ricompensa",
      none: "Nessuna missione attiva al momento. Torna presto per nuove sfide.",
      quest: "Missione",
      claimed: "Ricompensa missione riscattata: {{title}}",
    },
    community: {
      defaultTitle: "Obiettivo comunitario • Campagna invernale Switch",
      defaultDescription: "Acquista un titolo Switch e aiuta a sbloccare un drop per tutta la community.",
      defaultTargetLabel: "2,5k acquisti",
      contributors: "{{count}} contributori",
      complete: "{{percent}}% completato",
      target: "Obiettivo: {{target}}",
    },
    referral: {
      label: "Booster referral",
      cardSubheader: "Tieni traccia dei referral e dei traguardi di revenue share.",
      activeProgress: "Progresso attivo",
      maxReferrals: "Max: {{count}} referral",
      charged: "{{percent}}% carico",
      payout: "Payout {{percent}}%",
      currentPayoutSale: "Payout attuale: {{percent}}% su ogni vendita",
      maxPayout: "Payout massimo {{percent}}",
      keepPowered: "Mantieni carico il tuo Booster referral invitando giocatori con il tuo link.",
      verifiedPurchase: "Ogni acquisto verificato tramite il tuo link ti paga il {{percent}}% dell'ordine e sblocca nuove ricompense per te e il tuo team.",
      purchaseGeneric: "Ogni acquisto tramite il tuo link ti paga una percentuale della vendita e sblocca nuove ricompense.",
      shareIt: "Condividilo su social, stream o chat: ogni ordine tracciato carica automaticamente il tuo booster.",
      lastReferral: "Ultimo referral: {{date}}",
      lastReferralCaptured: "Ultimo referral registrato: {{date}}",
      linkLabel: "Il tuo link referral",
      copy: "Copia",
      copied: "Copiato",
      noCodeYet: "Un codice referral apparirà qui non appena il tuo booster sarà configurato.",
      codeLabel: "Codice referral: {{code}}",
      copySuccess: "Link copiato negli appunti.",
      copyErrorMessage: "Impossibile copiare automaticamente. Copia il link manualmente.",
      generatingCode: "Generazione del codice referral…",
      rewardsOverview: "Panoramica ricompense",
      pendingBalance: "Saldo in sospeso",
      perCurrency: "Per valuta",
      unpaid: "Non pagato: {{amount}}",
      lifetime: "Totale: {{amount}}",
      lifetimeEarnings: "Guadagni totali",
      trackedReferrals: "Referral tracciati",
      milestones: "Traguardi",
      referralsCount: "{{count}} referral",
      revenueSharePercent: "{{percent}}% revenue share",
      activeMessage: "Booster referral attivo.",
      maxedMessage: "Hai sbloccato la quota massima di revenue. Continua così!",
      maxedSoonMessage: "Booster referral al massimo! Ricompensa in arrivo.",
      inviteMore: "Invita ancora {{count}} amici per sbloccare il {{percent}}% di revenue share.",
    },
    share: {
      title: "Condividi il tuo obiettivo",
      closeAria: "Chiudi finestra di condivisione",
      p1: "Condividi il tuo link referral sugli ultimi prodotti.",
      p2: "Generiamo automaticamente una didascalia per ogni piattaforma, includiamo il tuo link e la copiamo per pubblicare subito.",
      p3: "Ogni acquisto tramite il tuo link carica il booster e ti fa guadagnare una percentuale.",
      hypeLine: "Unisciti a me nelle missioni nel miglior negozio di videogiochi.",
      fbBoosterLine: "Sto caricando il mio Booster referral su BigSwiss!",
      fbClaimLine: "Riscatta una ricompensa con me!",
      igTags: "#BigSwiss #ReferralBooster #LootDrop",
      ttLine: "Si gioca con #BigSwiss",
      feedback: {
        sharedVia: "Condiviso tramite {{label}}.",
        copied: "Testo per {{label}} copiato. Incollalo se richiesto.",
        opened: "Aperto {{label}}. Se ti serve il testo, incolla quello copiato.",
      },
    },
    dashboard: {
      loadingTitle: "Caricamento dashboard",
      loadingSubheader: "Sincronizzazione dei tuoi dati obiettivi.",
      loadingBody: "Raccolta di missioni e statistiche referral...",
      errorTitle: "Dati dashboard non disponibili",
      errorSubheader: "Impossibile caricare i progressi più recenti.",
    },
    rewards: {
      title: "Ricompense",
      subheader: "Vantaggi in arrivo in base al livello",
      unlockAt: "Sblocco al Livello {{level}}",
      sample1: { title: "Livello 2 • Avviso drop del weekend", desc: "Accesso anticipato ai restock del weekend." },
      sample2: { title: "Livello 3 • 5% di sconto in negozio", desc: "Sconto automatico su ogni acquisto." },
      sample3: { title: "Livello 4 • Regalo misterioso", desc: "Omaggi trimestrali nella tua casella di posta." },
    },
    stats: {
      completedAchievements: "Obiettivi completati",
      lifetimeSpend: "Spesa totale",
      averageOrder: "Ordine medio",
      highestOrder: "Ordine più alto",
      totalPurchases: "Acquisti totali",
      itemsPurchased: "Articoli acquistati",
      purchases60Days: "Acquisti (60 giorni)",
      storefrontsConquered: "Vetrine conquistate",
      lastPurchase: "Ultimo acquisto",
      notYet: "Non ancora",
      currentLevel: "Livello attuale",
    },
  },
  achievementsData: {
    categories: {
      purchases: "Traguardi di acquisto",
      spending: "Maestria di spesa",
      loyalty: "Ricompense fedeltà",
      community: "Comunità e social",
      engagement: "Potentiatori di coinvolgimento",
    },
    common: { dash: "—", expired: "Scaduto", and: "e" },
    errors: { unable: "Impossibile caricare i trofei." },
    helper: {
      locked: "Resta sintonizzato — questa missione si sbloccherà con i prossimi strumenti della community.",
      completed: "Obiettivo sbloccato! Goditi la ricompensa.",
      moreCurrency: "Restano {{remaining}}.",
      moreCount: "Ancora {{count}} per arrivare.",
    },
    platforms: {
      purchasedCount_one: "Hai acquistato {{count}} articolo {{name}}.",
      purchasedCount_other: "Hai acquistato {{count}} articoli {{name}}.",
    },
    levels: {
      L1: { name: "Nuovo sfidante", benefits: { 1: "XP di benvenuto", 2: "Accesso anticipato ai drop del weekend" } },
      L2: { name: "Cacciatore di bottino", benefits: { 1: "3% di sconto sui giochi a prezzo pieno", 2: "Giveaway mensile loot‑crate" } },
      L3: { name: "Razziatore d'élite", benefits: { 1: "5% di sconto in tutto il negozio", 2: "Accesso prioritario ai restock" } },
      L4: { name: "Campione mitico", benefits: { 1: "7% di sconto", 2: "Regalo misterioso trimestrale" } },
      L5: { name: "Guardiano leggendario della volta", benefits: { 1: "10% di sconto", 2: "Drop di merchandising VIP", 3: "Concierge del bottino personale" } },
    },
    defs: {
      "first-purchase": { title: "Primo bottino ottenuto", desc: "Completa il tuo primo ordine nello shop BigSwiss." },
      "repeat-shopper": { title: "Acquirente combo", desc: "Ottieni 5 acquisti riusciti su qualsiasi piattaforma." },
      "seasoned-shopper": { title: "Collezionista esperto", desc: "Raggiungi 10 ordini pagati per ottenere il badge." },
      "haul-master": { title: "Architetto dell'inventario", desc: "Acquista in totale 20 articoli individuali." },
      "recent-activity": { title: "Guerriero del weekend", desc: "Completa 3 acquisti negli ultimi 60 giorni." },
      "high-ticket": { title: "Cacciatore di grandi acquisti", desc: "Effettua un singolo acquisto di almeno 100 nella tua valuta." },
      "silver-saver": { title: "Risparmiatore argento", desc: "Accumula 250 di spesa totale per sbloccare sconti migliori." },
      "gold-saver": { title: "Accumulatore oro", desc: "Raggiungi 500 di spesa totale per un pacchetto regalo." },
      "platinum-saver": { title: "Investitore platino", desc: "Investe 1.000 in giochi e accessori per vantaggi leggendari." },
      "loyalty-gift": { title: "Insider dei regali", desc: "Completa 12 ordini pagati per ricevere regali stagionali e sorprese." },
      "vip-raffle": { title: "Accesso alle estrazioni VIP", desc: "Sblocca partecipazioni automatiche con 18 acquisti." },
      "platform-steam": { title: "Pioniere Steam", desc: "Acquista un prodotto Steam dal vault BigSwiss.", cta: "Acquista una chiave Steam per sbloccare questo badge." },
      "platform-rockstar": { title: "Insider Rockstar", desc: "Assicurati un prodotto Rockstar e mostra il tuo Social Club.", cta: "Prendi un codice Rockstar per entrare nel club." },
      "platform-ea": { title: "Prodigio EA Play", desc: "Aggiungi un titolo EA Play alla tua libreria e continua la serie.", cta: "Acquista un prodotto EA Play per sbloccare questo obiettivo." },
      "platform-gog": { title: "Esploratore GOG Galaxy", desc: "Acquista un classico DRM‑free da GOG.com tramite BigSwiss.", cta: "Acquista un prodotto GOG.com per esplorare la galassia." },
      "platform-ubisoft": { title: "Agente Ubisoft", desc: "Prendi un titolo Ubisoft Connect ed entra nell'Animus con stile.", cta: "Acquista un prodotto Ubisoft per sbloccare questa missione." },
      "platform-microsoft": { title: "Comandante Microsoft Store", desc: "Acquista una chiave Xbox Live o Microsoft Store.", cta: "Acquista un prodotto Xbox Live per ottenere questo badge." },
      "platform-xbox-series-x": { title: "Stratega Series X|S", desc: "Aggiungi un titolo Series X|S alla tua libreria next‑gen.", cta: "Acquista un gioco Xbox Series X|S per ottenere questo obiettivo." },
      "platform-xbox-360": { title: "Storico Xbox 360", desc: "Prendi un classico Xbox 360 e mantieni vivo il retaggio.", cta: "Acquista un gioco Xbox 360 per sbloccare questo badge storico." },
      "platform-xbox-gift-card": { title: "Booster portafoglio Xbox", desc: "Ricarica il portafoglio Xbox con una gift card.", cta: "Acquista una gift card Xbox per attivare vantaggi del portafoglio." },
      "platform-playstation-4": { title: "Icona PS4", desc: "Assicurati un titolo PlayStation 4 e prosegui l'eredità DualShock.", cta: "Acquista un gioco PS4 per aggiungere questa icona alla tua bacheca." },
      "platform-playstation-5": { title: "Avanguardia PS5", desc: "Aggiungi un'uscita PS5 all'avanguardia alla tua collezione.", cta: "Acquista un gioco PS5 per mostrare la maestria next‑gen." },
      "platform-psn-gift-card": { title: "Portafoglio PSN ricaricato", desc: "Ricarica il portafoglio PSN con una gift card.", cta: "Acquista una gift card PSN per sbloccare questo bonus." },
      "platform-switch-game": { title: "Capitano cartuccia", desc: "Prendi un gioco Nintendo Switch.", cta: "Acquista un titolo Switch per conquistare questo traguardo." },
      "platform-switch-gift-card": { title: "Investitore eShop", desc: "Riempi il portafoglio eShop con una gift card.", cta: "Acquista una gift card Switch per sbloccare bonus eShop." },
      "platform-jumper": { title: "Saltatore di piattaforme", desc: "Acquista in ogni vetrina principale per dimostrare la tua versatilità." },
      "xbox-master": { title: "Maestro Xbox", desc: "Acquista Series X|S, Xbox 360 e una gift card Xbox.", complete: "Tutte le vie Xbox sbloccate. Grandezza Game Pass raggiunta!", missing: "Acquista {{list}} per completare questa maestria." },
      "playstation-master": { title: "Maestro PlayStation", desc: "Raccogli PS4, PS5 e acquisti portafoglio PSN.", complete: "Dominio DualSense sbloccato. Benvenuto nel circolo d'élite!", missing: "Acquista {{list}} per completare questa maestria." },
      "switch-master": { title: "Esploratore Switch", desc: "Acquista un gioco Switch e una gift card.", complete: "Joy‑Con carichi. Maestria Switch raggiunta!", missing: "Acquista {{list}} per completare questa maestria." },
      "bulk-double-down": { title: "Raddoppia", desc: "Due articoli in un unico ordine.", complete: "Checkout multiplo padroneggiato.", cta: "{{remaining}} articolo/i in più in un unico ordine per sbloccare." },
      "bulk-triple-play": { title: "Tripla mossa", desc: "Raggruppa tre prodotti al checkout.", complete: "Checkout multiplo padroneggiato.", cta: "{{remaining}} articolo/i in più in un unico ordine per sbloccare." },
      "bulk-quad-squad": { title: "Quad Squad", desc: "Acquista quattro articoli contemporaneamente.", complete: "Checkout multiplo padroneggiato.", cta: "{{remaining}} articolo/i in più in un unico ordine per sbloccare." },
      "bulk-five-stack": { title: "Cinquina", desc: "Cinque prodotti in un unico ordine.", complete: "Checkout multiplo padroneggiato.", cta: "{{remaining}} articolo/i in più in un unico ordine per sbloccare." },
      "bulk-tenfold": { title: "Dieci volte", desc: "Dieci articoli in un mega checkout.", complete: "Checkout multiplo padroneggiato.", cta: "{{remaining}} articolo/i in più in un unico ordine per sbloccare." },
      "gift-giver": { title: "Stagione del dono", desc: "Regala un gioco o ricarica per sbloccare presto ricompense festive.", cta: "Le missioni regalo arrivano con il prossimo aggiornamento festivo." },
      "holiday-hero": { title: "Eroe delle feste", desc: "Completa un ordine speciale durante il festival invernale.", cta: "Obiettivi festivi a tempo limitato in arrivo più avanti nella stagione." },
      "preorder-pioneer": { title: "Pioniere del preordine", desc: "Assicurati un'uscita in arrivo prima del day‑one.", cta: "Il tracciamento dei preorder si attiverà non appena saranno disponibili." },
      "day-one-champion": { title: "Campione day‑one", desc: "Acquista un titolo entro 24 ore dal lancio.", cta: "Il tracciamento del day‑one arriva con il nostro prossimo ciclo di release." },
      "wishlist-closer": { title: "Chiusura wishlist", desc: "Acquista qualcosa direttamente dalla tua lista desideri.", cta: "Il tracciamento lista desideri‑carrello si attiverà con il prossimo aggiornamento." },
      "wishlist-sweeper": { title: "Pulizia wishlist", desc: "Svuota l'intera lista desideri durante una promozione.", cta: "Le pulizie della lista desideri si attiveranno con il nuovo sistema." },
      "payment-explorer": { title: "Esploratore dei pagamenti", desc: "Prova metodi di pagamento alternativi per ottenere bonus.", cta: "Il tracciamento multi‑metodo di pagamento arriva con l'upgrade del checkout." },
      "high-roller-weekend": { title: "Weekend high‑roller", desc: "Raggiungi una soglia di spesa in un weekend promo.", cta: "Resta sintonizzato — missioni di spesa evento in arrivo con promo stagionali." },
      "subscription-keeper": { title: "Custode dell'abbonamento", desc: "Mantieni un abbonamento attivo per tre mesi di fila.", cta: "Il tracciamento degli abbonamenti è in roadmap — resta aggiornato." },
      "social-twitter": { title: "Annunciatore X", desc: "Collega X per annunciare immediatamente i nuovi drop.", complete: "Il tuo profilo X è sincronizzato. Continua a caricare la squadra!", cta: "Collega X (Twitter) nelle Impostazioni di accesso per sbloccare ricompense social." },
      "social-facebook": { title: "Costruttore Meta", desc: "Connetti Facebook per giveaway esclusivi.", complete: "Facebook collegato. Sei pronto per regali esclusivi per i follower.", cta: "Collega Facebook nelle Impostazioni di accesso per sbloccare le lotterie della community." },
      "social-google": { title: "Accesso Google Vault", desc: "Assicura Google per un checkout fluido e premi.", complete: "Google collegato. Accessi istantanei e vantaggi cloud attivati.", cta: "Collega Google nelle Impostazioni di accesso per ottenere questo badge di sicurezza." },
      "social-steam": { title: "Leader party Steam", desc: "Collega Steam per sincronizzare e bonus multigiocatore.", complete: "Steam collegato. Inviti alla squadra e missioni di tempo di gioco sbloccati.", cta: "Collega Steam nelle Impostazioni di accesso per entrare nella serie di missioni multigiocatore." },
      "social-xbox": { title: "Avanguardia Xbox Live", desc: "Connetti Xbox Live per boost e missioni su console.", complete: "Xbox Live collegato. Drop su console e vantaggi Game Pass attivati.", cta: "Collega Xbox Live nelle Impostazioni di accesso per ottenere questo badge console." },
      "social-epic": { title: "Esploratore Epic", desc: "Connetti Epic Games per drop tra negozi.", complete: "Epic collegato. Sorprese cross‑store in arrivo.", cta: "Collega Epic Games nelle Impostazioni di accesso per sbloccare questo badge del caveau." },
      "social-discord": { title: "Leader squadrone Discord", desc: "Collega Discord per giveaway riservati alla community.", complete: "Discord collegato. Avvisi community e raid attivi.", cta: "Collega Discord nelle Impostazioni di accesso per sbloccare giveaway della community." },
      "social-rockstar": { title: "Capo crew Rockstar", desc: "Collega Rockstar Social Club per bonus automatici.", complete: "Account Rockstar collegato. Colpi e ricompense di banda sincronizzati automaticamente.", cta: "Collega Rockstar Social Club nelle Impostazioni di accesso per ottenere questo badge di crew." },
      "social-apple": { title: "Guardiano Apple", desc: "Connetti Apple ID per checkout rapidissimo e bonus.", complete: "Apple collegato. Acquisti sicuri e bonus portafoglio attivati.", cta: "Collega Apple ID nelle Impostazioni di accesso per assicurarti questo obiettivo." },
      "social-twitch": { title: "Squadra Twitch", desc: "Connetti Twitch per drop e ricompense streamer.", complete: "Twitch collegato. I drop arrivano direttamente nel tuo caveau.", cta: "Collega Twitch nelle Impostazioni di accesso per sbloccare i bonus streamer." },
      "social-nintendo": { title: "Stratega Switch", desc: "Connetti Nintendo per acquisti eShop e monete d'oro.", complete: "Nintendo collegato. I tuoi acquisti eShop ora contribuiscono alle missioni BigSwiss.", cta: "Collega Nintendo nelle Impostazioni di accesso per sbloccare bonus multipiattaforma." },
      "social-kick": { title: "Capitano Kick", desc: "Collega Kick per pool di bottino dei creator.", complete: "Kick collegato. I drop esclusivi dei creator compaiono nel feed.", cta: "Collega Kick nelle Impostazioni di accesso per sbloccare i vantaggi creator." },
      "social-x": { title: "Comandante del hype X", desc: "Connetti X per trasmettere i nuovi drop.", complete: "X collegato. Condividi avvisi direttamente dalla tua timeline.", cta: "Collega X nelle Impostazioni di accesso per sbloccare ricompense social." },
      "community-review": { title: "Campione recensioni", desc: "Lascia 3 recensioni per ottenere omaggi bonus.", cta: "Le recensioni arrivano con la prossima versione del nostro hub fedeltà." },
      "social-share": { title: "Macchinista dell'hype", desc: "Condividi il bottino sui social per sbloccare drop influencer.", cta: "Tieni d'occhio la funzione share‑to‑win la prossima stagione." },
      "daily-login": { title: "Serie accessi giornalieri", desc: "Mantieni una serie di 7 giorni quando attiva.", cta: "Il tracciamento delle serie giornaliere arriverà presto nel rewards hub." },
      "browser-alerts": { title: "Boost del segnale", desc: "Abilita notifiche browser per non perdere nulla.", cta: "Le ricompense per le notifiche browser arriveranno con l'aggiornamento degli avvisi." },
    },
    jumper: { complete: "Tutte le vetrine completate. Acquirente leggendario!", stillNeed: "Manca:", andMore: ", e altro" },
  },
  noFavorites: "Ops! Nessun bottino trovato!",
  noFavoritesText: "È ora di cacciare qualche bottino epico!",
  favorites: "Preferiti",
  purchases: "Acquisti",
  points: "Punti",
  dashboard: "Pannello di controllo",
  settings: "Impostazioni",
  updateSettings: "Aggiorna impostazioni",
  security: "Sicurezza",
  invoiceNotFound: "Fattura non trovata",
  action: "Azione",
  date: "Data",
  rowsPerPage: "Righe per pagina",
  aboutOurApi: "Informazioni sulla nostra API",
  aboutOurApiDescription:
    "Benvenuto nella nostra pagina del prodotto API! La nostra API offre un accesso senza soluzione di continuità a oltre 10.000 prodotti, garantendo che tu possa integrare e offrire una vasta gamma di articoli ai tuoi clienti in ogni momento. Che tu stia costruendo una piattaforma di e-commerce, un'app mobile o qualsiasi altro servizio, la nostra API ti copre.",
  whyChooseOurApi: "Perché scegliere la nostra API?",
  whyChooseOurApiDescription:
    "La nostra API è progettata per essere robusta, affidabile e facile da usare. Ecco alcune delle caratteristiche chiave:",
  featureApi1: "Accesso a oltre 10.000 prodotti",
  featureApi2: "Disponibilità e prezzi dei prodotti in tempo reale",
  featureApi3: "Alta disponibilità con il 99,9% di uptime",
  featureApi4: "Documentazione completa e supporto",
  featureApi5: "Facile integrazione con endpoint RESTful",
  featureApi6: "Architettura sicura e scalabile",
  WithOurApi:
    "Con la nostra API, puoi garantire ai tuoi clienti l'accesso a un vasto inventario di prodotti in ogni momento. La nostra alta disponibilità e gli aggiornamenti in tempo reale significano che non perderai mai una vendita.",

  aboutOurPosTerminals: "Informazioni sui nostri terminali POS",
  welcomeMessage:
    "Benvenuti nella nostra pagina prodotti! Siamo orgogliosi di offrire terminali POS all'avanguardia progettati specificamente per negozi che vendono giochi e carte di abbonamento. I nostri terminali sono facili da usare, sicuri ed efficienti, aiutandoti a gestire le tue vendite e il tuo inventario con facilità",
  whyChooseOurPosTerminals: "Perché scegliere i nostri terminali POS?",
  posTerminalFeatures:
    "I nostri terminali POS sono dotati di una serie di funzionalità per semplificare le operazioni del tuo negozio:",
  feature1:
    "Integrazione senza soluzione di continuità con i tuoi sistemi esistenti",
  feature2: "Elaborazione dei pagamenti rapida e sicura",
  feature3: "Gestione dell'inventario in tempo reale",
  feature4: "Interfaccia user-friendly per una formazione rapida",
  feature5:
    "Impostazioni personalizzabili per adattarsi alle esigenze del tuo negozio",
  posTerminalDescription:
    "Che tu stia vendendo giochi fisici o carte di abbonamento digitali, i nostri terminali POS sono equipaggiati per gestire tutte le tue transazioni in modo efficiente. Migliora l'esperienza dei tuoi clienti e aumenta le tue vendite con le nostre soluzioni POS affidabili e versatili",
  invoiceNo: "Numero fattura",
  howTo: "Come",
  activate: "Attivare",
  step: "Passo",
  giftToFriend: "Regala a un amico",
  enterEmailTwice:
    "Inserisci due volte l'indirizzo e-mail del tuo amico per conferma.",
  friendEmail: "E-mail dell'amico",
  confirmFriendsEmail: "Conferma l'e-mail dell'amico",
  emailsDoNotMatch: "Gli indirizzi e-mail non corrispondono. Riprova.",
  sendGift: "Invia regalo",
  giftSent: "Regalo inviato",
  giftSentMessage:
    "Abbiamo inviato con successo la chiave come regalo al tuo amico all'indirizzo email seguente:",
  close: "Chiudi",

  buyers: "Acquirenti",
  reviews: "Recensioni",
  user: "Utente",
  comment: "Commento",

  requirements: "Requisiti",
  minimumRequirements: "Requisiti minimi",
  recommendedRequirements: "Requisiti consigliati",
  OS: "Sistema operativo",
  Processor: "Processore",
  Memory: "Memoria",
  Graphics: "Grafica",
  DirectX: "DirectX",
  Storage: "Memorizzazione",
  AdditionalNotes: "Note aggiuntive",

  careers: "Carriere",
  contactUs: "Contattaci",
  updatePersonalData: "Aggiorna i dati di fatturazione",
  updateApplicationSettings: "Aggiorna impostazioni dell'applicazione",
  birthday: "Data di nascita",
  yourName: "Il tuo nome",
  yourLastName: "Il tuo cognome",
  enterEmail: "Inserisci il tuo indirizzo email",
  yourEmail: "Il tuo indirizzo email",
  changePassword: "Cambia password",
  currentPassword: "Password attuale",
  newPassword: "Nuova password",
  confirmPassword: "Conferma password",
  showLess: "Mostra meno",
  showMore: "Mostra di più",
  PageNotFound: "Pagina non trovata",
  DontGiveUp: "Non arrenderti, forse troverai qui quello che stai cercando.",
  Jobs: "Lavori",
  ElevateYourCareer:
    "Elevate la tua carriera con Bigswiss GmbH, dove innovazione e passione si incontrano. Immergiti in un mondo in cui il tuo lavoro modella direttamente il futuro del gioco e della tecnologia.",
  exploreOpportunities:
    "Esplora opportunità, affronta sfide e fai parte di un team dinamico dedicato all'eccellenza. Il tuo viaggio per fare la differenza inizia qui.",
  enterYourEmailAddress: "Inserisci il tuo indirizzo email",
  yourEmailAddress: "Il tuo indirizzo email",
  contactUsAgree: 'Cliccando su "Contattaci" accetti i nostri',
  termsAndConditions: "Termini e condizioni",
  bigswissSupport: "Contatta Bigswiss ",
  support: "Supporto",
  contactDescription:
    "Dalle richieste sul nostro negozio online innovativo e il negozio all'ingrosso all'assistenza per le nostre applicazioni per chioschi per gli acquisti di videogiochi e il negozio API all'ingrosso, siamo qui per migliorare la tua esperienza.",
  connectTeam:
    "Connettiti con il nostro team dedicato per funzionalità e servizi di alto livello progettati appositamente per te.",

  pricingDescription: "Scegli il piano che soddisfa le tue esigenze",
  basic: "Base",
  pro: "Pro",
  enterprise: "Impresa",
  getStarted: "Inizia",
  startNow: "Inizia ora",
  mostPopular: "Più popolare",
  perMonth: "al mese",
  basicDesc1: "Accesso API per fino a 100 richieste al mese",
  basicDesc2: "Analisi e report di base",
  basicDesc3: "Supporto standard",
  proDesc1: "Accesso API per fino a 10.000 richieste al mese",
  proDesc2: "Analisi e report avanzati",
  proDesc3: "Supporto prioritario",
  proDesc4: "Accesso a offerte esclusive di giochi e carte di abbonamento",
  enterpriseDesc1: "Richieste API illimitate",
  enterpriseDesc2: "Analisi e report personalizzati",
  enterpriseDesc3: "Supporto dedicato 24/7",
  enterpriseDesc4: "Soluzioni terminali POS personalizzate",
  enterpriseDesc5: "Migliori prezzi per acquisti all'ingrosso",

  chooseActivation: "Scegli dove desideri attivare il tuo prodotto.",
  thankYouForPurchase: "Grazie per il tuo acquisto!",
  findYourKeysBellow: "Di seguito troverai le tue chiavi e la tua fattura.",
  productKey: "Chiave del prodotto",
  productKeys: "Chiavi del prodotto",
  productActivation: "Attivazione del prodotto",
  productActivationDescription:
    "Segui le istruzioni di seguito per attivare il tuo prodotto.",
  sendAsGift: "Regalo",
  hide: "Nascondi",
  viewKeys: "Visualizza le chiavi",
  purchase_review_pending:
    "Il tuo acquisto è in fase di revisione. Riceverai una e-mail una volta approvato.",
  // getting_key_please_wait: "Getting your key. Please wait...",
  getting_key_please_wait:
    "Stiamo recuperando la tua chiave. Attendere prego...",
  downloadInvoice: "Scarica la fattura",
  download: "Scarica",
  back: "Indietro",
  next: "Avanti",
  activationMethod: "Metodo di attivazione",
  keylessActivation: "Attivazione senza chiave",
  activationLink: "Link di attivazione",
  enterTheKey: "Inserisci la chiave",
  confirmActivation: "Conferma attivazione",
  battlenetStep1:
    "Fai clic sul pulsante qui sotto per accedere alla pagina di attivazione della chiave Battle.net.",
  goToBattlenetActivation: "Vai alla pagina di attivazione di Battle.net",
  battlenetStep2:
    "Accedi con le tue credenziali Battle.net. Se non hai un account, creane uno gratuitamente.",
  battlenetStep3:
    "Inserisci la chiave ricevuta nel campo apposito, quindi fai clic su 'Riscatta'.",
  battlenetStep4:
    "Congratulazioni! Hai attivato il tuo prodotto con successo ed è pronto per essere scaricato e giocato sul tuo account Battle.net.",
  goToActivation: "Vai all'attivazione",
  battlenetStep2app:
    "Apri l'app Blizzard Battle.net. E accedi con le tue credenziali Battle.net. Se non hai un account, creane uno gratuitamente.",
  battlenetStep3app:
    "Fai clic sul tuo profilo per aprire un menu, quindi fai clic su 'Riscatta codice'.",

  goToSteamActivation: "Vai alla pagina di attivazione di Steam",
  steamStep1:
    "Fai clic sul pulsante qui sotto per accedere alla pagina di attivazione della chiave Steam.",
  steamStep2:
    "Accedi con le tue credenziali Steam. Se non hai un account, creane uno gratuitamente.",
  steamStep3:
    "Leggi e accetta l'accordo di abbonamento Steam, quindi fai clic su 'Continua'.",
  steamStep4:
    "Congratulazioni! Hai attivato il tuo prodotto con successo ed è pronto per essere scaricato e giocato sul tuo account Steam.",
  steamStep2app:
    "Apri l'app Steam e accedi con le tue credenziali Steam. Se non hai un account, creane uno gratuitamente.",
  steamStep3app:
    "Fai clic su 'Giochi' nel menu in alto, quindi fai clic su 'Attiva un prodotto su Steam'.",
  steamStep4app:
    "Inserisci la chiave ricevuta nel campo apposito, quindi fai clic su 'Convalida'.",

  goToMicrosoftActivation:
    "Vai alla pagina di attivazione del Microsoft Store",
  microsoftStep1:
    "Fai clic sul pulsante in basso per accedere alla pagina di attivazione del codice Microsoft Store.",
  microsoftStep2:
    "Accedi con le tue credenziali Microsoft. Se non hai un account, creane uno gratuitamente.",
  microsoftStep3:
    "Inserisci il codice ricevuto nel campo fornito e fai clic su 'Avanti'.",
  microsoftStep4:
    "Congratulazioni! Hai attivato con successo il tuo prodotto ed è pronto per essere scaricato e giocato sul tuo account Microsoft.",
  microsoftStep2app:
    "Sul tuo sistema Windows, apri l'app Microsoft Store e accedi con le tue credenziali Microsoft. Se non hai un account, creane uno gratuitamente.",
  microsoftStep3app:
    "Fai clic sull'icona del profilo in alto a destra, quindi fai clic su 'Riscatta codice o carte regalo'.",

  goToGOGActivation: "Vai alla pagina di attivazione GOG",
  activateKey: "Attiva la chiave",
  linkToAccount: "Collega all'account",
  gogStep1:
    "Clicca sul pulsante qui sotto per andare alla pagina di attivazione della chiave GOG.",
  gogStep2: "Clicca su 'Continua' per confermare l'attivazione della chiave.",
  gogStep3: "Clicca su 'Accedi' per collegare la chiave al tuo account GOG.",
  gogStep4:
    "Accedi con le tue credenziali GOG. Se non hai un account, creane uno gratuitamente.",
  gogStep5:
    "Congratulazioni! Hai attivato con successo il tuo prodotto ed è pronto per essere scaricato e giocato sul tuo account GOG.",

  gogStep2app:
    "Apri l'app GOG Galaxy e accedi con le tue credenziali GOG. Se non hai un account, creane uno gratuitamente.",
  gogStep3app:
    "Fai clic su 'Aggiungi giochi e amici' nel menu in alto, quindi fai clic su 'Riscatta codice GOG'.",
  gogStep4app:
    "Inserisci la chiave ricevuta nel campo fornito, quindi fai clic su 'Continua'.",

  goToEpicActivation: "Vai alla pagina di attivazione di Epic Games",
  epicStep1:
    "Fai clic sul pulsante qui sotto per andare alla pagina di attivazione della chiave Epic Games.",
  epicStep2:
    "Fai clic su 'Riscatta' per confermare l'attivazione della chiave.",
  epicStep3:
    "Fai clic su 'Accedi' per collegare la chiave al tuo account Epic Games.",
  epicStep4:
    "Accedi con le tue credenziali Epic Games. Se non hai un account, creane uno gratuitamente.",
  epicStep5:
    "Congratulazioni! Hai attivato con successo il tuo prodotto ed è pronto per essere scaricato e giocato sul tuo account Epic Games.",
  epicStep2app:
    "Apri l'app Epic Games e accedi con le tue credenziali Epic Games. Se non hai un account, creane uno gratuitamente.",
  epicStep3app:
    "Fai clic sul tuo profilo nell'angolo in alto a destra, quindi fai clic su 'Riscatta codice'.",
  epicStep4app:
    "Inserisci la chiave ricevuta nel campo fornito, quindi fai clic su 'Riscatta'.",

  goToRockstarActivation: "Vai alla pagina di attivazione Rockstar",
  rockstarStep1:
    "Clicca sul pulsante qui sotto per andare alla pagina di attivazione della chiave Rockstar.",
  rockstarStep2:
    "Accedi con le tue credenziali Rockstar. Se non hai un account, creane uno gratuitamente.",
  rockstarStep3:
    "Attendere il caricamento della pagina e il completamento della validazione Rockstar. Questo potrebbe richiedere alcuni minuti. Una volta che la pagina è stata caricata, vedrai un messaggio di conferma. Clicca su 'Conferma' per attivare la chiave sul tuo account Rockstar.",
  rockstarStep4:
    "Congratulazioni! Hai attivato con successo il tuo prodotto, ed è pronto per essere scaricato e giocato sul tuo account Rockstar.",
  rockstarStep2app:
    "Apri l'app Rockstar Games Launcher e accedi con le tue credenziali Rockstar. Se non hai un account, creane uno gratuitamente.",
  rockstarStep3app:
    "Clicca sul menu nell'angolo in alto a destra, poi su 'RISCUOTI CODICE'.",
  rockstarStep4app:
    "Inserisci la chiave ricevuta nel campo fornito, poi clicca su 'VERIFICA'.",
  rockstarStep5app:
    "Leggi e accetta i termini e le condizioni, poi clicca su 'RISCUOTI'.",

  goToEAPlayActivation: "Vai alla pagina di attivazione di EA Play",
  eaStep1:
    "Clicca sul pulsante qui sotto per accedere alla pagina di attivazione della chiave EA Play.",
  eaStep2:
    "Accedi con le tue credenziali EA Play. Se non hai un account, creane uno gratuitamente.",
  eaStep3:
    "Inserisci la chiave che hai ricevuto nel campo fornito, quindi clicca su 'Avanti'.",
  eaStep4:
    "Clicca su 'Avanti' per collegare la chiave al tuo account EA Play.",
  eaStep5:
    "Congratulazioni! Hai attivato con successo il tuo prodotto, ed è pronto per essere scaricato e giocato sul tuo account EA Play.",

  eaStep2app:
    "Apri l'app EA Play e accedi con le tue credenziali EA Play. Se non hai un account, creane uno gratuitamente.",
  eaStep3app:
    "Clicca sul menu in alto a destra, quindi clicca su 'Riscatta Codice'.",
  eaStep4app:
    "Inserisci la chiave che hai ricevuto nel campo fornito, quindi clicca su 'Avanti'.",

  ubisoftStep2app:
    "Apri l'app Ubisoft e accedi con le tue credenziali Ubisoft. Se non hai un account, creane uno gratuitamente.",
  ubisoftStep3app:
    "Clicca sul menu del profilo in alto a sinistra, quindi clicca su 'Attivazione chiave'.",
  ubisoftStep4app:
    "Inserisci il codice ricevuto nel campo previsto, quindi clicca su 'Attiva'.",

  goToSwitchActivation: "Vai alla pagina di attivazione Nintendo Switch",
  openeshop: "Apri eShop",
  selectUser: "Seleziona Utente",
  redeem: "Riscatta Chiave",
  switchStep1:
    "Clicca sul pulsante qui sotto per accedere alla pagina di attivazione della chiave Nintendo Switch.",
  switchStep2:
    "Accedi con le tue credenziali Nintendo Switch. Se non hai un account, creane uno gratuitamente.",
  switchStep3:
    "Inserisci la chiave che hai ricevuto nel campo fornito, quindi clicca su 'Continua'.",
  switchStep4:
    "Congratulazioni! Hai attivato con successo il tuo prodotto, ed è pronto per essere scaricato e giocato sul tuo account Nintendo Switch.",
  switchStep1app: "Apri l'app Nintendo eShop.",
  switchStep2app: "Seleziona l'account su cui desideri attivare il prodotto.",
  switchStep3app:
    "Inserisci la chiave che hai ricevuto nel campo fornito, quindi clicca su 'Conferma'.",
  switchstep4app:
    "Seleziona 'Riscatta' e clicca su 'Conferma' per attivare il prodotto sul tuo account Nintendo Switch.",

  goToPlayStationActivation: "Vai alla pagina di attivazione di PlayStation",
  openLogin: "Apri il login",
  psStep1:
    "Clicca qui sotto per andare alla pagina di attivazione PlayStation.",
  psStep2: "In alto a destra, clicca su 'Accedi'",
  psStep3:
    "Accedi con le tue credenziali PlayStation. Se non hai un account, creane uno gratuitamente.",
  psStep4:
    "In alto a destra, clicca sul tuo profilo, quindi su 'Riscatta codice'.",
  psStep5:
    "Inserisci la chiave che hai ricevuto nel campo previsto, quindi clicca su 'Continua'.",
  psStep6:
    "Congratulazioni! Hai attivato con successo il tuo prodotto. È pronto per essere scaricato e giocato sul tuo account PlayStation.",
  openStore: "Apri il Negozio",
  psStep2console: "Seleziona il PlayStation Store a sinistra e premi 'X'.",
  psStep3console:
    "Premi '△' per accedere al menu in alto a destra, seleziona '...' e seleziona 'Riscatta codice'.",
  psStep4console:
    "Inserisci il codice ricevuto nel campo fornito, quindi fai clic su 'Riscatta'.",
  psStep2app: "Apri l'app PlayStation e apri il PlayStation Store.",
  openMenu: "Apri il menu",
  psStep3app:
    "Seleziona il menu in alto a destra per visualizzare ulteriori opzioni.",
  psStep4app: "Seleziona 'Riscatta codice'.",

  goToXboxActivation: "Vai alla pagina di attivazione Xbox",
  xboxStep1:
    "Clicca sul pulsante qui sotto per andare alla pagina di attivazione della chiave Xbox.",
  xboxStep2:
    "Clicca su 'Accedi per riscattare' per accedere con le tue credenziali Xbox. Se non hai un account, creane uno gratuitamente.",
  xboxStep3:
    "Clicca su 'Riscatta ora' per aprire la finestra di attivazione della chiave.",
  xboxStep4:
    "Inserisci la chiave che hai ricevuto nel campo fornito, quindi clicca su 'Avanti'. Continua a seguire le istruzioni.",
  xboxStep5:
    "Congratulazioni! Hai attivato con successo il tuo prodotto ed è pronto per essere scaricato e giocato sul tuo account Xbox.",
  xboxStep2console:
    "Premi il pulsante Xbox sul tuo controller per aprire la guida. Mentre sei connesso al tuo account, seleziona 'Store'.",
  xboxStep3console:
    "Una volta aperto, premi il pulsante Visualizza sul tuo controller per aprire il menu, quindi seleziona 'Riscatta'.",
  xboxStep4console:
    "Inserisci la chiave che hai ricevuto nel campo fornito, quindi clicca su 'Controlla codice'.",

  warningModalTitle: "Avviso Importante",
  warningModalMessage1:
    "Una volta rivelata la chiave, perdi il diritto a un rimborso immediato.",
  warningModalMessage2:
    "Sarai idoneo per un rimborso solo se la chiave è invalida.",
  doYouWantToProceed: "Vuoi procedere?",
  revealKey: "Rivela la chiave",
  // CHAT
  helpCenter: "Centro assistenza",
  talkWithourSupport: "Parla con il supporto",
  haveAquestion: "Hai una domanda?",
  typeAmessage: "Digita un messaggio...",
  hello: "Ciao",
  howCanIHelpYou: "Come posso aiutarti?",
  home: "Casa",
  history: "Storia",
  help: "Aiuto",
  noChatMessages: "Non hai ancora alcuna cronologia della chat.",
  allHelpTopics: "Tutti gli argomenti di aiuto",
  searchTopics: "Cerca argomenti...",
  noTopicsFound: "Nessun argomento trovato.",

  redeemingCodesCategory: "Riscatto dei codici",
  findingCodesCategory: "Ricerca di codici",
  invoicesCategory: "Fatture",
  codeActivationIssueCategory: "Problemi di attivazione del codice",
  identityVerificationCategory: "Verifica dell'identità",

  howToRedeem: "Come riscattare il codice?",
  whereToFindCodes: "Dove posso trovare i miei codici?",
  whereToGetInvoice: "Dove posso ottenere la fattura del mio acquisto?",
  issuesActivatingCode: "Ho problemi ad attivare il mio codice",
  issuesIdentityVerification:
    "Ho problemi con la verifica della mia identità",

  howToRedeemDesc:
    "Segui i passaggi seguenti per riscattare correttamente il tuo codice:",
  findingCodesDesc: "Segui i passaggi seguenti per trovare il tuo codice:",
  invoicesDesc:
    "Per accedere a una fattura del tuo acquisto, segui i passaggi seguenti:",
  activationIssueDesc:
    "Se riscontri problemi nell'attivare il tuo codice, verifica quanto segue:",
  identityVerificationDesc:
    "Se stai affrontando difficoltà con la verifica dell'identità, assicurati di:",

  accessAccountTitle: "Accedi al tuo account",
  accessAccountDesc:
    "Fai clic sull'icona utente situata nell'angolo in alto a destra della pagina.",

  navigatePurchasesTitle: "Vai agli acquisti",
  navigatePurchasesDesc:
    "Nel menu a discesa, seleziona 'Acquisti' per visualizzare le tue transazioni recenti.",

  selectRelevantPurchaseTitle: "Seleziona l'acquisto pertinente",
  selectRelevantPurchaseDesc:
    "Nella tabella degli acquisti, seleziona la transazione associata al codice che desideri attivare.",

  viewKeysTitle: "Visualizza i codici disponibili",
  viewKeysDesc:
    "Fai clic su 'Visualizza Codici' per mostrare un elenco di codici prodotto disponibili per l'attivazione.",

  revealKeyTitle: "Mostra il codice",
  revealKeyDesc:
    "Fai clic sull'icona a forma di occhio per visualizzare il codice che desideri attivare.",

  activateKeyTitle: "Attiva il codice",
  activateKeyDesc:
    "Fai clic sul pulsante 'Attiva' e segui le istruzioni sullo schermo.",

  downloadInvoiceTitle: "Scarica la fattura",
  downloadInvoiceDesc:
    "Fai clic sul pulsante 'Scarica Fattura' per accedere a una copia PDF della tua fattura.",

  checkTyposTitle: "Controlla errori di battitura",
  checkTyposDesc:
    "Assicurati di aver inserito correttamente il codice, senza errori di battitura.",

  verifyUsageTitle: "Verifica l'uso del codice",
  verifyUsageDesc: "Assicurati che il codice non sia già stato utilizzato.",

  correctPlatformTitle: "Piattaforma corretta",
  correctPlatformDesc:
    "Assicurati di utilizzare il codice sulla piattaforma o applicazione corretta.",

  clearDocumentsTitle: "Documenti chiari",
  clearDocumentsDesc:
    "I tuoi documenti d'identità devono essere chiari e leggibili.",

  matchPersonalInfoTitle: "Corrispondenza dei dati personali",
  matchPersonalInfoDesc:
    "I tuoi dati personali devono corrispondere ai registri.",

  supportedVerificationMethodTitle: "Metodo di verifica supportato",
  supportedVerificationMethodDesc:
    "Stai utilizzando un metodo di verifica supportato.",

    notesContactSupport:
      "Se il problema persiste, contatta il nostro team di supporto per ulteriore assistenza.",
    stillHavingIssue: "Continua ad avere problemi con",
    pleaseLoginToSeeTicketHistory:
      "Accedi per visualizzare la cronologia dei ticket.",
  }
};
